import { render, staticRenderFns } from "./MessageNavItem.vue?vue&type=template&id=2c3dd487&scoped=true"
import script from "./MessageNavItem.vue?vue&type=script&lang=js"
export * from "./MessageNavItem.vue?vue&type=script&lang=js"
import style0 from "./MessageNavItem.vue?vue&type=style&index=0&id=2c3dd487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3dd487",
  null
  
)

export default component.exports